import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const Ctx = createContext(null);

export function AdminProvider({ children }) {
  const [staff, setStaff] = useState(null);
  useEffect(() => {
    api.get("/admin-auth/me").then((r) => setStaff(r.data)).catch(async () => {
      try {
        await api.post("/admin-auth/refresh");
        setStaff((await api.get("/admin-auth/me")).data);
      } catch {
        setStaff(false);
      }
    });
  }, []);
  const login = async (email, password) => setStaff((await api.post("/admin-auth/login", { email, password })).data);
  const logout = async () => { await api.post("/admin-auth/logout"); setStaff(false); };
  return <Ctx.Provider value={{ staff, login, logout, can: (p) => !!staff?.permissions?.[p] }}>{children}</Ctx.Provider>;
}

export const useAdmin = () => useContext(Ctx);

export const ROLE_LABEL = { super_admin: "Super Admin", admin: "Admin", account_manager: "Account Manager", user: "Client" };
export const ROLE_C = {
  super_admin: "bg-[#7C3AED]/10 text-[#7C3AED]", admin: "bg-[#007AFF]/10 text-[#007AFF]",
  account_manager: "bg-[#0891B2]/10 text-[#0891B2]", user: "bg-zinc-100 text-zinc-600",
};
export const RoleChip = ({ role, testid }) => (
  <span data-testid={testid} className={`text-[10px] font-semibold uppercase tracking-wide px-2 py-0.5 rounded-sm ${ROLE_C[role]}`}>{ROLE_LABEL[role] || role}</span>
);
